<template>
    <div id="uploadCL">
        <template v-for="(item,index) in list">

            <info-title :title-content="item.title" vertical-line="true"/>
            <template v-for="(item1,index1) in item.dataList">
                <info-title :title-content="item1.title" :required-description="item1.isRequired"/>
                <van-cell-group>

                    <van-uploader
                        class="uploader"
                        v-model="allList[item1.key]"
                        :name="item1.cllx"
                        :max-count="item1.limit"
                        :after-read="fileUpload"
                        :before-read="beforeRead"
                        :before-delete="deleteCl"
                    ></van-uploader>
                    <div class="uploading-wrap" v-show="isUpload">
                        <div class="upload-text">
                            <van-loading class="icon-upload"  type="spinner" />
                            <span>上传中...</span>
                        </div>
                    </div>

                </van-cell-group>
            </template>

        </template>
        <div class="uploading-wrap" v-show="isUpload">
            <div class="upload-text">
                <van-loading class="icon-upload"  type="spinner" />
                <span>上传中...</span>
            </div>
        </div>
    </div>
</template>

<script>
import InfoTitle from '../../../components/common/InfoTitle';
import {Notify} from "vant";

// 引用 —— 调用接口
import {uploadTuiBao,delUploadTB} from "./../../../api/common";

export default {
name: "uploadCL",
    data(){
        return {
            tbsqs: [],
            isUpload: false,
            config: {
                tbsqs: {
                    title: '退保申请书（必填）',
                    accept: '.doc,.docx,.pdf,.jpg,.jpeg,.png,.bmp,.gif',

                    name: '退保申请书',
                    listName: 'tbsqsList',
                    cllx: 1,
                    fileTypeStr: 'fileTypeStr1',

                    limit: 5,
                    uploadParams: {},
                    check: true
                },
                tbyjzmcl: {
                    title: '退保依据证明材料（必填）',
                    accept: '.doc,.docx,.pdf,.jpg,.jpeg,.png,.bmp,.gif,.mp3,.wma,.wav',

                    name: '退保依据证明材料',
                    listName: 'tbyjzmclList',
                    cllx: 2,
                    fileTypeStr: 'fileTypeStr2',

                    limit: 20,
                    uploadParams: {},
                    check: true
                },
                qtcl: {
                    title: '其他材料（非必填）',
                    accept: '.doc,.docx,.pdf,.jpg,.jpeg,.png,.bmp,.gif,.mp3,.wma,.wav',

                    name: '其他材料',
                    listName: 'qtclList',
                    cllx: 255,
                    fileTypeStr: 'fileTypeStr2',

                    limit: 20,
                    uploadParams: {},
                    check: false
                },
            },
            fileTypeStr1: ' doc、docx、pdf、jpg、jpeg、png、bmp、gif ',
            fileTypeStr2: ' doc、docx、pdf、jpg、jpeg、png、bmp、gif、mp3、wma、wav ',
            allList: {
                tbsqs: [],
                tbyjzmcl: [],
                qtcl: []
            },
            transform:{
                1:'tbsqs',
                2:'tbyjzmcl',
                255:'qtcl'
            },
            list: [{
                title: '上传材料',
                dataList: [
                    {
                        title: '退保申请书',
                        isRequired: '必填',
                        key: 'tbsqs',
                        value: [],
                        cllx: 1,
                        limit: 5,
                        check: true
                    },
                    {
                        title: '退保依据证明材料',
                        isRequired: '必填',
                        key: 'tbyjzmcl',
                        value: [],
                        cllx: 2,
                        limit: 20,
                        check: true
                    },
                    {
                        title: '其他材料',
                        isRequired: '非必填',
                        key: 'qtcl',
                        value: [],
                        cllx: 255,
                        limit: 20,
                        check: false
                    }
                ],
            }]

        }
    },
    props:['dbid','tbid'],
    components: {InfoTitle},
    computed:{},
    methods: {
        // 上传验证
        beforeRead(file) {
            console.log('--beforeRead 111',file);
            if (file.size == 0) {
                Notify('上传文件必须大于0kb!')
            }
            let fileType = "image/jpeg||image/jpg||image/png||image/bmp||image/gif"
            let imgFormat = "jpg、jpeg、png、bmp、gif"
            if (fileType.indexOf(file.type) === -1) {
                Notify({
                    message: `仅支持格式为${imgFormat}的图片!`,
                    type: 'danger',
                    duration: 5 * 1000
                })
                return false;
            } else if (file.size > (20 * 1024 * 1024)) {
                Notify('上传文件大小不能超过 20MB!')
                return false;
            }
            return true;
        },
        async fileUpload(file, info) {
            console.log('--fileUpload 111',file,info);
            this.isUpload = true;
            this.$emit('changeDownloaded', false);
            let currentDbid = this.dbid;
            const time3=(Math.random()*100).toFixed(2);
            let clid = new Date().getTime()+time3;
            let cllx = info.name;
            let f = file.file;
            const fd = new FormData();
            fd.append("files", f);
            fd.append("cllx", cllx);
            fd.append("dbid", currentDbid);
            fd.append("tbid", this.tbid);
            fd.append("clid", clid);

            uploadTuiBao(fd).then(res=>{
                this.isUpload = false
                file.cId=res.data?res.data.cId:'';
                file.type=this.transform[info.name];
                if(res.code === 200){
                    this.$notify({'type': 'success', 'message': '材料上传成功'});
                }else{
                    this.$notify(res.message);
                }
                this.$emit('changeDownloaded', true);
                console.log('--allList',this.allList);
            }).catch(function (error) {
                this.$emit('changeDownloaded', true);
                console.log(error)
            });
        },
        deleteCl: function (file) {
            console.log('--deleteCl 111',file);
            if(this.isUpload !== true){
                delUploadTB({id:file.cId}).then(res=>{
                    console.log('--res',res);
                    this.$notify({'type': 'success', 'message': '材料删除成功'});
                    this.tbsqs=this.tbsqs.filter(i=>i.cId!==file.cId);
                    this.allList[file.type]=this.allList[file.type].filter(i=>i.cId!==file.cId);
                    console.log('--deleteCl 222',this.tbsqs);
                }).catch(function (error) {
                    console.log(error)
                });
            }else{
                this.$notify("上传过程中不能删除！");
            }
        },
        check_submit(){
            const allList=this.allList;
            const dataList=this.list[0].dataList;
            var message='';
            for(let i=0,max=dataList.length;i<max;i++){
                if(dataList[i].check&&allList[dataList[i].key].length<=0){
                    message='请上传'+dataList[i].title;
                    break;
                }
            }
            message&&Notify(message);
            return !message;
        }
    },
    created() {
        console.log('--uploadCL created 123',this.dbid,this.tbid);
    }
}
</script>

<style lang="less" scoped>
.uploading-wrap {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.15);
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -60px;
    margin-left: -60px;
    z-index: 99;
    display:flex;
    justify-content:center;
    align-items:center;
}

.upload-text{
    .icon-upload{
        text-align:center;
    }
    >span{
        font-size:18px;
        color:#fff;
    }
}
</style>
